<template>
  <div>
    <v-card
      elevation="0"
      class="rounded-lg"
      :key="reRender"
      :class="!isEdit ? 'mouse-cursor' : ''"
    >
      <div class="pa-4 d-flex align-center">
        <div class="flex-column" style="position: relative">
          <v-img
            v-if="!isEdit"
            class="rounded-lg no-filter"
            width="100"
            height="100"
            :src="
              getImage(avatar) ||
              require('@/app/user-module/assets/images/user-placeholder.png')
            "
            lazy-src="@/app/user-module/assets/images/user-placeholder.png"
            cover
          />

          <image-uploader
            v-else
            id="logo"
            :maxWidth="1024"
            :maxHeight="1024"
            :quality="0.9"
            :autoRotate="true"
            outputFormat="blob"
            :preview="false"
            :className="['fileinput', { 'fileinput--loaded': hasLogo }]"
            :capture="false"
            accept="image/*"
            doNotResize="['gif', 'svg']"
            @input="setLogo"
          >
            <label for="logo" slot="upload-label">
              <a>
                <v-img
                  v-if="logoUrl"
                  class="image-custom-preview"
                  :src="logoUrl"
                />

                <div v-if="!hasLogo" class="upload-caption gray1--text">
                  <v-img
                    v-if="avatar"
                    class="rounded-lg no-filter"
                    width="100"
                    height="100"
                    :src="
                      getImage(avatar) ||
                      require('@/app/user-module/assets/images/user-placeholder.png')
                    "
                    lazy-src="@/app/user-module/assets/images/user-placeholder.png"
                    cover
                  />

                  <v-img
                    v-else
                    class="rounded-lg no-filter"
                    width="100"
                    height="100"
                    lazy-src="@/app/user-module/assets/images/user-placeholder.png"
                    contain
                  />
                </div>
              </a>
            </label>
          </image-uploader>

          <float-btn
            v-if="isEditable && havePermissionUpdateOrganization"
            :isEdit="isEdit"
            @save="onClick"
            @edit="isEdit = true"
            :bottom="true"
            :loading="savingData"
          />
        </div>

        <div
          class="
            ps-4
            d-flex
            flex-column
            text-start
            justify-center
            flex-grow-1 flex-shrink-0
          "
        >
          <div :style="isEdit ? 'pointer-events: all' : 'pointer-events: none'">
            <LocalisedContentEditable
              :values="name"
              @update:values="
                values => ((this.name = values), (this.nameError = false))
              "
              :text-area-outlined="false"
              :editable="true"
              css-class="text-h1 font-weight-regular textLight--text"
              :showLanguageTabs="false"
            />
            <div v-if="nameError" class="caption error--text">
              {{ $t("inputRules.requiredField") }}
            </div>
          </div>

          <div class="body-2 textLight--text text-ellipse-1">
            {{ this.totalEmployees ? this.totalEmployees : 0 }}
            {{ $t("user.employees.employees") }}
          </div>
        </div>
      </div>
    </v-card>
    <v-row>
      <v-col>
        <CropperModal ref="cropperModal" @croppedData="croppedData" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LocalisedContentEditable from "../../../core-module/components/LocalisedContentEditable.vue";
import FloatBtn from "../../../user-module/components/employee-profile/FloatBtn.vue";
import CropperModal from "../../../core-module/components/CropperModal.vue";

import { createOrUpdateOrganization } from "../../methods/createOrUpdateOrganization";
import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  components: {
    FloatBtn,
    LocalisedContentEditable,
    CropperModal,
  },
  data() {
    return {
      savingData: false,
      organizationProfile: null,
      avatar: "",
      name: "",
      totalEmployees: 0,
      isEdit: false,
      isEditable: true,
      logoUrl: null,
      hasLogo: false,
      reRender: 0,
      nameError: false,
    };
  },
  computed: {
    havePermissionUpdateOrganization() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["UPDATE_ORGANIZATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  props: {
    organizationData: {
      type: Object,
      default: () => {},
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    organizationData: {
      immediate: true,
      handler() {
        this.organizationProfile = this.organizationData
          ? this.organizationData
          : null;
        this.resetFormData();
      },
      deep: true,
    },
  },
  methods: {
    resetFormData() {
      this.avatar = this.organizationProfile?.logo;
      this.name = this.organizationProfile?.name;
      this.totalEmployees = this.organizationProfile?.totalEmployees;

      this.reRender++;
    },

    async onClick() {
      this.nameError = !this.filterEmptyLocalisedValues(this.name).length
        ? true
        : false;

      if (this.nameError) return;

      if (this.organizationProfile._id) {
        this.savingData = true;
        this.isEdit = false;

        let saveData = {
          _id: this.organizationProfile._id,
          name: this.filterEmptyLocalisedValues(this.name),
        };
        if (this.avatar instanceof Blob) saveData.logo = this.avatar;
        await createOrUpdateOrganization(saveData).then(response => {
          this.savingData = false;
        });
      }
    },
    setLogo(output) {
      this.hasLogo = true;
      var reader = new FileReader();
      reader.readAsDataURL(output);
      var self = this;

      reader.onloadend = function () {
        var base64data = reader.result;
        // self.categoryInput.url = base64data;
        self.logoUrl = base64data;
        self.$refs.cropperModal.show(self.logoUrl);
      };
      this.avatar = output;
    },
    croppedData(blobData, base64Data) {
      this.avatar = blobData;
      this.logoUrl = base64Data;
    },
  },
};
</script>
<style>
#fileInput {
  display: none;
}

#logo {
  display: none;
}
</style>
<style scoped>
.image-custom-preview {
  height: 100px !important;
  width: 100px !important;
  border-radius: 10px;
}
.hide-underline >>> .v-input__slot::before {
  border-style: none !important;
}
.hide-underline >>> .v-input__slot::after {
  border-style: none !important;
}
</style>
